import { rest } from "@auto/services";
import { getServiceUri } from "@auto/metadata";

import { LIMIT } from "./constants";

const search = async (entity, payload) => {
  return await rest.request(
    getServiceUri() + `${entity}/search`,
    "POST",
    payload
  );
};

const allQuery = () => ({
  columns: [],
  query: "",
  limit: LIMIT,
  offset: 0,
});

const eqQuery = (field, value) => ({
  columns: [],
  query: `${field}==${value}`,
  limit: LIMIT,
  offset: 0,
});

export const loadRoots = async () => {
  const [departments, constituencies, arrondissements] = await Promise.all([
    search("department", allQuery()),
    search("constituency", allQuery()),
    search("arrondissement", allQuery()),
  ]);

  return {
    departments: departments || [],
    constituencies: constituencies || [],
    arrondissements: arrondissements || [],
  };
};

export const loadArrondissements = async (departmentGid) => {
  return (await search("arrondissement", eqQuery("departmentGid", departmentGid))) || [];
};

export const loadCommunesByArrondissement = async (arrondissementGid) => {
  return (await search("commune", eqQuery("arrondissementGid", arrondissementGid))) || [];
};

export const loadCommunesByConstituency = async (constituencyGid) => {
  return (await search("commune", eqQuery("constituencyGid", constituencyGid))) || [];
};

export const loadSections = async (communeGid) => {
  return (await search("section", eqQuery("communeGid", communeGid))) || [];
};

export const loadVotingCenters = async (sectionGid) => {
  return (await search("voting-center", eqQuery("sectionGid", sectionGid))) || [];
};

export const enableVotingCenter = async (gid) => {
  return await rest.request(
    getServiceUri() + `voting-center-management/${gid}/enable`,
    "POST",
    {}
  );
};

export const disableVotingCenter = async (gid) => {
  return await rest.request(
    getServiceUri() + `voting-center-management/${gid}/disable`,
    "POST",
    {}
  );
};

export const createEntity = async (entity, payload) => {
  requireGeographyEntity(entity);

  return await rest.request(
    getServiceUri() + entity,
    "POST",
    payload
  );
};

const GEOGRAPHY_ENTITIES = new Set([
  "department",
  "arrondissement",
  "constituency",
  "commune",
  "section",
  "voting-center",
]);

const requireGeographyEntity = (entity) => {
  if (!GEOGRAPHY_ENTITIES.has(entity)) {
    throw new Error(`Unknown geography entity: ${entity}`);
  }
};

const normalizePutUpdatePayload = (entity, payload) => {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new Error(`${entity}: PUT update payload must be an object.`);
  }

  const { id, ...cleanPayload } = payload;

  if (
    cleanPayload.gid === undefined ||
    cleanPayload.gid === null ||
    cleanPayload.gid === ""
  ) {
    throw new Error(`${entity}: gid is required for PUT update.`);
  }

  return cleanPayload;
};

export const updateEntity = async (entity, payload) => {
  requireGeographyEntity(entity);

  return await rest.request(
    getServiceUri() + entity,
    "PUT",
    normalizePutUpdatePayload(entity, payload)
  );
};
